<template>
  <span class="agent-switch" :class="{ 'is-disabled': disabled }">
    <input
      type="checkbox"
      :checked="!!value"
      :disabled="disabled"
      :aria-label="ariaLabel"
      @change="$emit('input', $event.target.checked)"
    />
    <span class="agent-switch-slider"></span>
  </span>
</template>

<script>
export default {
  name: "ToggleSwitch",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    ariaLabel: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.agent-switch {
  position: relative;
  display: inline-block;
  flex: 0 0 40px;
  width: 40px;
  height: 22px;
  vertical-align: middle;
}
.agent-switch input {
  position: absolute;
  inset: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}
.agent-switch-slider {
  position: absolute;
  inset: 0;
  z-index: 1;
  border-radius: 999px;
  background: #cbd5e1;
  pointer-events: none;
  transition: background .18s ease;
}
.agent-switch-slider:before {
  position: absolute;
  content: "";
  width: 16px;
  height: 16px;
  left: 3px;
  top: 3px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(16, 24, 40, .16);
  transition: transform .18s ease;
}
.agent-switch input:checked + .agent-switch-slider {
  background: #fe9b44;
}
.agent-switch input:checked + .agent-switch-slider:before {
  transform: translateX(18px);
}
.agent-switch input:focus + .agent-switch-slider {
  box-shadow: 0 0 0 3px rgba(254, 155, 68, .2);
}
.agent-switch input:disabled {
  cursor: not-allowed;
}
.agent-switch.is-disabled {
  cursor: not-allowed;
}
.agent-switch.is-disabled .agent-switch-slider {
  cursor: not-allowed;
  opacity: .6;
}
</style>



// WEBPACK FOOTER //
// src/views/ai/agentV2/components/ToggleSwitch.vue